import { get } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { changeCode, REDUCER_NAME } from '../reducer';
import { SearchFilter } from '../../../common/search-filter';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../app/commonReducer';
import { withComponentId } from './../../../common/ComponentIdContext';
import { compose } from 'redux';

class SearchBox extends Component {
  clickItemSearch = currentSearch => {
    const { changeCode, componentId, syncType } = this.props;
    changeCode(currentSearch, componentId);
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: currentSearch,
    });
  };

  render() {
    const {
      currentSearch,
      listOrganizationByOrganCode,
      listCompanyGroupByComGroupCode,
      coveredWarrantDataByCode,
    } = this.props;
    return (
      <SearchFilter
        schema={[
          { key: 'displayCode', className: 'w-20' },
          { key: 'codeName', className: 'w-55 text-truncate' },
          {
            key: 'exchange',
            className: 'w-25 text-right',
            render: text => {
              return text.toUpperCase();
            },
          },
        ]}
        listKeyFilter={['displayCode', 'codeName']}
        getListSearchFromRedux={state => [
          ...state[COMMON_REDUCER_NAME].listOrganizationSearch,
          ...state[COMMON_REDUCER_NAME].listCompanyGroup,
          ...state[COMMON_REDUCER_NAME].listCoveredWarrant,
        ]}
        currentSearch={
          {
            ...listOrganizationByOrganCode,
            ...listCompanyGroupByComGroupCode,
            ...coveredWarrantDataByCode,
          }[currentSearch.code] || currentSearch
        }
        mainKey={'code'}
        sortKey={'displayCode'}
        clickItemSearch={this.clickItemSearch}
      />
    );
  }
}

const mapDispatchToProps = {
  changeCode,
};

const mapStateToProps = (state, { componentId, componentName }) => {
  return {
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    listCompanyGroupByComGroupCode:
      state[COMMON_REDUCER_NAME].listCompanyGroupByComGroupCode,
    coveredWarrantDataByCode:
      state[COMMON_REDUCER_NAME].coveredWarrantDataByCode,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SearchBox);
